namespace RioERP.Enquiry {
    export interface EnquiryForm {
        EnquiryName: Serenity.StringEditor;
        EEnquiryMode: Serenity.EnumEditor;
        EnquiryType: Serenity.EnumEditor;
        CustomerId: Serenity.LookupEditor;
        Mobile1: Serenity.StringEditor;
        EmailId1: Serenity.EmailEditor;
        EStatus: Serenity.EnumEditor;
        EnquiryDate: Serenity.DateEditor;
        FollowupDate: Serenity.DateEditor;
        FollowUpTime: FollowUpTimeEditor;
        EnquiryProducts: Serenity.LookupEditor;
        HandledBy: Serenity.LookupEditor;
        Address1: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.LookupEditor;
        Pincode: Serenity.IntegerEditor;
        Country: Serenity.StringEditor;
        Note: Serenity.TextAreaEditor;
        EnquiryFollowUp: EnquiryFollowupEditor;
    }

    export class EnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'Enquiry.Enquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EnquiryForm.init)  {
                EnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EmailEditor;
                var w4 = s.DateEditor;
                var w5 = FollowUpTimeEditor;
                var w6 = s.IntegerEditor;
                var w7 = s.TextAreaEditor;
                var w8 = EnquiryFollowupEditor;

                Q.initFormType(EnquiryForm, [
                    'EnquiryName', w0,
                    'EEnquiryMode', w1,
                    'EnquiryType', w1,
                    'CustomerId', w2,
                    'Mobile1', w0,
                    'EmailId1', w3,
                    'EStatus', w1,
                    'EnquiryDate', w4,
                    'FollowupDate', w4,
                    'FollowUpTime', w5,
                    'EnquiryProducts', w2,
                    'HandledBy', w2,
                    'Address1', w0,
                    'City', w0,
                    'StateId', w2,
                    'Pincode', w6,
                    'Country', w0,
                    'Note', w7,
                    'EnquiryFollowUp', w8
                ]);
            }
        }
    }
}
